import React, { useState, useEffect } from 'react';
import {PlayAudio} from './playAudio';
// import { Howl } from 'howler';
import useCounterStore from '../store/useCounterStore';
import useSpeakCountStore from "../store/useSpeakCountStore";
// import { sendMessage } from './messageService'; // 暫時取消firebase功能
import '../animation/styles.css';

const TicketMachine = () => {
  const [preparingItems, setPreparingItems] = useState([]);
  const [doneItems, setDoneItems] = useState([]);
  const [clearItems, setClearItems] = useState([]);
  const [makingMin, setMakingMin] = useState(0);
  const [makingCups, setMakingCups] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const increase = useCounterStore((state) => state.increase);
  const getItems = () => useSpeakCountStore.getState().getItems();
  const [currentIP, setCurrentIP] = useState('');


  const getVisitorIp = async () => {
    let ip = "0.0.0.0";
    await fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then((json) => {
      // console.log(json.ip);
      ip = json.ip;
    });
    return ip;
  }

  const updateItems = async ({ preparing = [], done = [], clear = [], totalAmount = -1, totalTime = -1 }) => {
    let theIP = "";
    if (currentIP === '') {
      try {
        theIP = await getVisitorIp();
        setCurrentIP(theIP);
      } catch (error) {
        console.log("沒成功獲取到 IP, 其錯誤為 : ", error);
        theIP = error;
      }
    }

    console.log("getVisitorIp() : ", currentIP);
    
    // 暫時取消firebase功能
    // handleSend({preparing, done, clear, totalAmount, totalTime, ip: currentIP===''?theIP:currentIP});

    if (done.length > 0) {
      done.map((item) => {
        console.log("ticket machine got stored items : ", getItems());
        let playedItems = getItems();
        if (playedItems.includes(item)) {
          console.log(`${item}已經撥放過，跳過不撥放`);
          return false;
        } else {
          console.log("要播放的 號碼 : ", item);
          increase();
          PlayAudio(item);
          return true;
        }
      });
      // setTimeout(PlayAudio(done), count*3000);
      // console.log("wait time(ms) : ", count*3000);
    }
    // 現有狀態的一份複製，用來移除已存在的元素
    let newPreparingItems = [...preparingItems];
    let newDoneItems = [...doneItems];
    let newClearItems = [...clearItems];

    // 移除所有三個狀態中已存在的元素
    const allItems = new Set([...newPreparingItems, ...newDoneItems, ...newClearItems]);
    const allIncomingItems = [...preparing, ...done, ...clear];

    // 移除重複的元素
    allIncomingItems.forEach(item => {
      if (allItems.has(item)) {
        newPreparingItems = newPreparingItems.filter(it => it !== item);
        newDoneItems = newDoneItems.filter(it => it !== item);
        newClearItems = newClearItems.filter(it => it !== item);
      }
    });

    // 添加新元素到相應的狀態
    setPreparingItems([...newPreparingItems, ...preparing]);
    setDoneItems([...newDoneItems, ...done]);
    setClearItems([...newClearItems, ...clear]);

    if (totalAmount!==-1) setMakingCups(totalAmount);
    if (totalTime!==-1) setMakingMin(totalTime);
  };

  
  // useEffect(() => {
  //   // 绑定函数到 window 对象，以便外部调用
  //   window.getOrderStatus = updateItems;
  //   // console.log(window.getOrderStatus);
  
  //   // 组件卸载时移除绑定，防止内存泄漏或未预期调用
  //   return () => {
  //     window.getOrderStatus = undefined;
  //   };
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []); // 空数组确保这段代码只在组件挂载时运行一次

  // 暫時取消firebase功能
  // const handleSend = (message) => {
  //   sendMessage(message);
  // };

  useEffect(() => {
    window.getOrderStatus = updateItems;
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preparingItems, doneItems, clearItems, makingMin, makingCups]); // 監聽這些狀態變更以更新 window 上的方法

  // useEffect(() => {
  //   setAnimationMinClass('animate__animated animate__bounce');

  //     // 設置一個定時器來移除動畫類,這樣動畫就可以在下次狀態改變時重新觸發
  //     const timer = setTimeout(() => {
  //       setAnimationMinClass('');
  //     }, 1000); // 1000ms = 動畫持續時間
  
  //     // 清理函數
  //     return () => clearTimeout(timer);
  // }, [makingMin]); // 監聽這些狀態變更以更新 window 上的方法

  // useEffect(() => {
  //   setAnimationCupClass('animate__animated animate__bounce');
    
  //     // 設置一個定時器來移除動畫類,這樣動畫就可以在下次狀態改變時重新觸發
  //     const timer = setTimeout(() => {
  //       setAnimationCupClass('');
  //     }, 1000); // 1000ms = 動畫持續時間
  
  //     // 清理函數
  //     return () => clearTimeout(timer);
  // }, [makingCups]); // 監聽這些狀態變更以更新 window 上的方法

  
  // === 背景音樂 + 全域 duck/unduck（不動 playAudio.js） ===
// 背景播放清單（讀 manifest.json）+ 依序循環 + duck/unduck（不修改 playAudio.js）
// useEffect(() => {
//   let disposed = false;

//   // ===== 可調參數 =====
//   const BASE_VOL     = 1.5;   // 背景原始音量
//   const DUCK_VOL     = 0.10;  // 前景音播放時壓低到的音量
//   const ATTACK_MS    = 180;    // 降音時間
//   const RELEASE_MS   = 1000;   // 回復時間
//   const CROSSFADE_MS = 500;   // 曲與曲之間交疊淡入淡出毫秒（0 = 不交疊）
//   const MANIFEST_URL = '/res/audio/bgm/manifest.json';

//   // 會追蹤目前活動中的 BGM Howl（交疊時可能 >1）
//   const bgmSet = new Set();
//   let desiredBgmVol = BASE_VOL;

//   // 依序建立/切歌
//   const makeBgm = (playlist, index, startMuted = false) => {
//     const h = new Howl({
//       src: [playlist[index]],
//       loop: false, // 我們自己接手下一首
//       volume: startMuted ? 0 : desiredBgmVol,
//       html5: false // 使用 WebAudio
//     });
//     h._isBgm = true; // 標記為背景，猴補時跳過
//     bgmSet.add(h);

//     h.on('end', () => {
//       if (disposed) return;
//       const nextIndex = (index + 1) % playlist.length;
//       const next = makeBgm(playlist, nextIndex, CROSSFADE_MS > 0);

//       if (CROSSFADE_MS > 0) {
//         next.play();                        // 下一首先以 0 音量播放
//         next.fade(0, desiredBgmVol, CROSSFADE_MS);
//         h.fade(h.volume(), 0, CROSSFADE_MS);
//         setTimeout(() => {
//           try { h.stop(); } catch {}
//           try { h.unload(); } catch {}
//           bgmSet.delete(h);
//         }, CROSSFADE_MS + 20);
//       } else {
//         try { h.unload(); } catch {}
//         bgmSet.delete(h);
//         next.play();
//       }
//     });

//     return h;
//   };

//   // 同時淡入/淡出所有正在播放的 BGM（交疊期用得到）
//   const fadeAllBgmTo = (targetVol, ms) => {
//     bgmSet.forEach(h => {
//       try { h.fade(h.volume(), targetVol, ms); } catch {}
//     });
//   };

//   // 猴補 Howl.prototype.play：偵測「非 BGM」的播放（= 前景音 / playAudio.js）→ duck
//   const origPlay = Howl.prototype.play;
//   let fgActiveCount = 0;
//   const activeKeys = new Set();

//   Howl.prototype.play = function patchedPlay(...args) {
//     const id = origPlay.apply(this, args);
//     if (this._isBgm) return id; // 背景自己不算前景

//     const key = `${this._id || 'h'}:${id}`;
//     if (!activeKeys.has(key)) {
//       activeKeys.add(key);
//       fgActiveCount += 1;
//       if (fgActiveCount === 1) {
//         desiredBgmVol = DUCK_VOL;
//         fadeAllBgmTo(DUCK_VOL, ATTACK_MS);
//       }

//       // 針對「這次播放」監聽 end（指定 soundId）
//       this.once('end', (endedId) => {
//         const endedKey = `${this._id || 'h'}:${endedId}`;
//         if (activeKeys.has(endedKey)) {
//           activeKeys.delete(endedKey);
//           fgActiveCount = Math.max(0, fgActiveCount - 1);
//           if (fgActiveCount === 0) {
//             desiredBgmVol = BASE_VOL;
//             fadeAllBgmTo(BASE_VOL, RELEASE_MS);
//           }
//         }
//       }, id);
//     }
//     return id;
//   };

//   // 1) 先抓播放清單 manifest
//   const start = async () => {
//     try {
//       const resp = await fetch(MANIFEST_URL, { cache: 'no-store' });
//       const playlist = await resp.json();

//       if (disposed || !Array.isArray(playlist) || playlist.length === 0) {
//         console.warn('[BGM] manifest 為空或格式不正確：', playlist);
//         return;
//       }

//       // 2) 啟動第一首
//       const first = makeBgm(playlist, 0, false);
//       try { first.play(); } catch {}

//     } catch (err) {
//       console.error('[BGM] 載入 manifest 失敗：', err);
//     }
//   };

//   start();

//   // 清理：還原 play、停止並卸載所有 BGM
//   return () => {
//     disposed = true;
//     Howl.prototype.play = origPlay;
//     bgmSet.forEach(h => { try { h.stop(); } catch {}; try { h.unload(); } catch {} });
//     bgmSet.clear();
//   };
// }, []);




  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPage(prevPage => prevPage + 1);
    }, 10000); // 每10秒切换一次页面
    return () => clearInterval(interval);
  }, []);

  const getPageItems = (items, page) => {
    const start = page * 16;
    return items.slice(start, start + 16);
  };

  const renderItems = (items, type) => {
    return items.map((item, index) => {
      const commonStyle = {
        position: 'absolute',
        fontSize: '3vw',
        fontWeight: '300',
        letterSpacing: '1px',
        color: 'white',
        left: index > 11 ? `82vw` : index > 7 ? `69vw` : index > 3 ? '56vw' : '43vw',
        width: '100%'
      };

      let topOffset;
      if (type === 'preparing') {
        // topOffset = index >= 4 ? `${65 + (index - 4) * 7.2}vh` : `${65 + index * 7.2}vh`;
        topOffset = index >= 12 ? `${65 + (index - 12) * 7.6}vh` : index >= 8 ? `${65 + (index - 8) * 7.6}vh` : index >= 4 ? `${65 + (index - 4) * 7.6}vh` : `${65 + index * 7.6}vh`;
      } else if (type === 'done') {
        topOffset = index >= 12 ? `${17 + (index - 12) * 7.6}vh` : index >= 8 ? `${17 + (index - 8) * 7.6}vh` : index >= 4 ? `${17 + (index - 4) * 7.6}vh` : `${17 + index * 7.6}vh`;
      }
      // if (type === 'preparing') {
      //   topOffset = index > 5 ? `${65 + (index - 6) * 9}vh` : index > 2 ? `${65 + (index - 3) * 9}vh` : `${65 + index * 9}vh`;
      // } else if (type === 'done') {
      //   topOffset = index > 7 ? `${20 + (index - 6) * 9}vh` : index > 3 ? `${20 + (index - 3) * 9}vh` : `${20 + index * 9}vh`;
      // }

      return (
        <div
          // className='animated flipInX'
          key={item}
          style={{
            ...commonStyle,
            top: topOffset
          }}
        >
          {item}
        </div>
      );
    });
  };


  const maxPreparingPage = Math.ceil(preparingItems.length / 16);
  const maxDonePage = Math.ceil(doneItems.length / 16);

  const currentPreparingItems = getPageItems(preparingItems, currentPage % maxPreparingPage);
  const currentDoneItems = getPageItems(doneItems, currentPage % maxDonePage);

  const currentPreparingPage = (currentPage % maxPreparingPage) + 1;
  const currentDonePage = (currentPage % maxDonePage) + 1;
  

  return (
    <div className="container" 
      // style={{ width: '100vw', height: '100vh', position: 'relative' }}
      style={{
        position: 'relative',
        width: '100vw',
        height: '100vh',
        backgroundImage: 'url("res/machine.jpg")',
        backgroundPosition: 'center center',
        backgroundSize: 'contain', // 保持圖片比例並使整個圖片都能被完整顯示
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* <img
        src="res/machine.png"
        alt="Ticket Machine"
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      /> */}
      {/* {preparingItems.map((item, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            fontSize: '4vw', 
            color: 'white', 
            left: index > 5 ? '76vw' : index > 2 ? '63vw' : '50vw', 
            top: index > 5 ? `${20 + (index-6) * 9}vh` : index > 2 ? `${20 + (index-3) * 9}vh` : `${20 + index * 9}vh`,
            width: '100%', 
          }}
        >
          {item}
        </div>
      ))} */}
      <div className="preparing-item">
      {renderItems(currentPreparingItems, 'preparing')}
      </div>

      <div className="making-info">
        <div 
        className="cups"
        style={{
          position: 'absolute',
          fontSize: '1.9vw', 
          color: 'white', 
          left: makingCups>30 ? '57vw' : '59.5vw',
          top: '59.5vh',
          width: '100%', 
        }}
        >
        {/* {(31 > makingCups && makingCups > 0 ) && <div > {makingCups}&nbsp;杯 </div>}
        {makingCups > 30  && <div > 30 杯以上 </div>} */}
                {makingCups > 0 && <div > {makingCups}&nbsp;杯 </div>}
      </div>
      <div 
        className="mins"
        style={{
          position: 'absolute',
          fontSize: '1.9vw', 
          color: 'white', 
          left: makingCups>30 ? '66vw' : '64vw',
          top: '59.5vh',
          width: '100%', 
        }}
        >
          {/* {makingMin > 30  && <div>&nbsp;大於 30&nbsp;分鐘</div>} */}
          {(makingMin > 2) && <div>&nbsp;預計&nbsp;{makingMin}&nbsp;分鐘</div>}
          {(makingMin < 3 && makingMin > 0) && <div>&nbsp;預計&nbsp;馬上取餐</div>}
        </div>

        {maxPreparingPage > 1 && <div 
          className="pagination1"
          style={{
            position: 'absolute',
            fontSize: '1.5vw', 
            color: 'white', 
            left: '93vw',
            top: '90vh',
            width: '100%', 
          }}
          >{currentPreparingPage?currentPreparingPage:0}/{maxPreparingPage}</div>}
        {maxDonePage > 1 && <div 
          className="pagination2"
          style={{
            position: 'absolute',
            fontSize: '1.5vw', 
            color: 'white', 
            left: '93vw',
            top: '45vh',
            width: '100%', 
          }}
          >{currentDonePage?currentDonePage:0}/{maxDonePage}</div>}
      </div>

      <div className="done-item">
      {renderItems(currentDoneItems, 'done')}
      </div>
      {/* {doneItems.map((item, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            fontSize: '4vw', 
            color: 'white', 
            left: index > 5 ? '76vw' : index > 2 ? '63vw' : '50vw',
            top: index > 5 ? `${64 + (index-6) * 9}vh` : index > 2 ? `${64 + (index-3) * 9}vh` : `${64 + index * 9}vh`,
            width: '100%', 
          }}
        >
          {item}
        </div>
      ))} */}
    </div>
  );
};

export default TicketMachine;
